import Splide from '@splidejs/splide';

const durationAnim = 1;

export default class ImageGallery {
	static init() {
		Array.from(document.querySelectorAll('.image-gallery')).forEach(element => {
			new ImageGallery(element);
		});
	}

	constructor(element) {
        if (!element) {
            return;
        }
		this.directionsld = 'right';
		const gallerySplide = this.splideCreate(element.querySelector('.image-gallery__splide'));
		const lightboxSplide = this.splideCreate(element.querySelector('.image-gallery__lightbox-splide'));

        // on gallery click, open the lightbox
        element.querySelector('.image-gallery__splide').addEventListener('click', (e) => {
			if(e.target && e.target.closest('.image-gallery-slide__image-box')) {
				const lightboxElement = e.target.closest('.image-gallery').querySelector('.innsbruck-lightbox');
				const event = new Event('openLightbox', {bubbles: true});
				lightboxElement.dispatchEvent(event);

				// keep the sliders in sync
				lightboxSplide.go(gallerySplide.index);
			}
		});

        lightboxSplide.on('move', (newIndex, prevIndex, destIndex) => gallerySplide.go(newIndex));
	}

	splideCreate(splideElement) {
		const options = {
			type: 'fade',
			arrows: true,
			rewind: true,
			drag: false,
			pauseOnHover: false,
			pagination: false,
			keyboard: 'true',
			perPage: 1,
			gap: '0',
		};

        switch(document.documentElement.lang) {
            case 'de':
                options.i18n = {
                    prev: 'Vorheriges Bild',
                    next: 'Nächstes Bild',
                    first: 'Gehe zum ersten Bild',
                    last: 'Gehe zum letzten Bild',
                    slideX: 'Gehe zum Bild %s',
                    pageX: 'Gehe zur Seite %s',
                    play: 'Autoplay starten',
                    pause: 'Autoplay pausieren',
                }
                break;
            case 'it':
                options.i18n = {
                    prev: 'Immagine precedente',
                    next: 'Prossima immagine',
                    first: 'Vai alla prima immagine',
                    last: 'Vai all\'ultima immagine',
                    slideX: 'Vai all\'immagine %s',
                    pageX: 'Vai alla pagina %s',
                    play: 'Avvia autoplay',
                    pause: 'Metti in pausa autoplay',
                }
                break;
            default:
                options.i18n = {
                    prev: 'Previous image',
                    next: 'Next image',
                    first: 'Go to first image',
                    last: 'Go to last image',
                    slideX: 'Go to image %s',
                    pageX: 'Go to page %s',
                    play: 'Start autoplay',
                    pause: 'Pause autoplay',
                };
        }

		const splide = new Splide(splideElement, options).mount();
		splide.on('active', (e) => this.onSlideActive(e.slide));
		splide.on('inactive', (e) => this.onSlideInactive(e.slide));
		splide.on('move', (newIndex, prevIndex, destIndex) => this.onSlideMove(splide, newIndex, prevIndex, destIndex));

		let allInactiveCaptions = Array.from(splide.root.querySelectorAll('.caption')).splice(1);
		gsap.set(allInactiveCaptions, {opacity: 0});

		// Enforce z-index for next and pre slide
		if(splide.length > 1) splide.Components.Elements.slides[1].classList.add('next-slide');
        if(splide.length > 2) splide.Components.Elements.slides[splide.length - 1].classList.add('prev-slide');

		return splide;
	}

	onSlideInactive(slide) {
		gsap.to(slide.querySelectorAll('.caption'), {
			x: this.directionsld === "left" ? "25" : "-25",
			opacity: 0,
			duration: durationAnim / 2,
			ease: 'power4.out'
		});
	}

	onSlideActive(slide) {
		gsap.fromTo(
			slide.querySelector('.image-gallery-slide__image-box'),
			{
				clipPath: this.directionsld === "left" ? "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)" : "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)"
			},
			{
				duration: durationAnim,
				ease: 'power4.out',
				clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
				clearProps: 'clipPath'
			},
		);

		gsap.fromTo(
			slide.querySelector('img'),
			{scale: 1.35},
			{duration: durationAnim, ease: 'power4.out', scale: 1},
		);

		gsap.fromTo(
			slide.querySelector('.caption'),
			{x: this.directionsld === "left" ? "-25" : "25", opacity: 0},
			{
				opacity: 1,
				duration: durationAnim / 2,
				ease: 'power4.out',
				x: 0,
				delay: durationAnim / 5,
				clearProps: true
			},
		);
	}

	onSlideMove(splide, newIndex, prevIndex, destIndex) {
		this.directionsld = newIndex > prevIndex ? 'right' : 'left';

		splide.Components.Elements.slides.forEach(slide => {
			slide.classList.remove('prev-slide');
			slide.classList.remove('next-slide');
		});

		const prevSlide = newIndex>0 ? newIndex-1 : (splide.length - 1);
		let nextSlide = (newIndex === (splide.length - 1)) ? 0 : (newIndex + 1);
		splide.Components.Elements.slides[prevSlide].classList.add('prev-slide');
		splide.Components.Elements.slides[nextSlide].classList.add('next-slide');
	}
}
